export type Testimonial = { name: string; role: string; quote: string };

export const featuredTestimonial: Testimonial = {
  name: "Van-It",
  role: "Loueur de vans aménagés",
  quote:
    "Je fais totalement confiance à MANY Loisirs pour l'aménagement de mes véhicules de loisirs. En tant que professionnel de la location de vans aménagés, Many Loisirs est parfaitement à l'écoute de mes besoins. Et le travail est bien réalisé ! Je recommande à 100 %.",
};

export const testimonials: Testimonial[] = [
  {
    name: "Florent F.",
    role: "Client particulier",
    quote:
      "Très bon établissement à l'écoute du client. Véhicule très bien entretenu, ravi de mon achat. Je vous le recommande, sérieux dans leur travail. Merci !",
  },
  {
    name: "Christophe A.",
    role: "Client particulier",
    quote: "Très professionnel, à l'écoute de mes demandes, intérieur de qualité et très réactif. Je recommande.",
  },
  {
    name: "Axel",
    role: "Client particulier",
    quote:
      "Équipe professionnelle et passionnée ! J'ai eu la chance d'acheter un très beau T5 dans un état exceptionnel, rien à dire. Très content de la vente.",
  },
];
